import { Moment } from "moment";
import { SupportingDocumentDetails } from "src/app/shared/models/supporting-documents-claim-detail.model";

export interface AdjudicationBroadcastNameModel {
  broadcastNamePublishDate: BroadcastNamePublishDate[];
  primaryButVal: string;
  secondaryButVal: string;
  broadcastDocumentTypeLookup: [];
  details: AdjudicationDetailsModel;
}

export class AdjudicationDetailsModel {
  engagementId: string;
  creditorId: string;
  particularsOfDebtId: string;
  creditorName: string;
  proxyFormId: string;
  viewOrEdit: boolean;
  isEdit: boolean;
}
export class BroadcastNamePublishDate {
  broadcastNamePublishDate: string;
  id: string;
  publishDateTime:any
}

export class AdjudicationBroadcastProxyFormModel {
  engagementId: string;
  creditorId: string;
  particularsOfDebtId: string;
  broadcastId: string;
  publishedDate: Date;
  broadcastNameWithDate: string;
  originalFileName: string;
  filePath: string;
  fileSize: string;
  isSuperseded: boolean;
  documentTypeId: string;
  createdBy: string;
  remarks: string;
  proxyFormId: string;
  updatedBy: string;
  supersededProxyFormId:string;
  uploadedDatetime: string;

}

export class SupportingDocument {
  name: string;
  webkitRelativePath: string;
  lastModifiedDate: Date;
  size:number;
  convertedDate:any;
  date:Moment;
  filePath:string;
  fileSize:number;
  isUpdate:boolean;
  isView:boolean;
  showDelete:boolean;
  getDetails:SupportingDocument;
}

export class BroadcastProxyFormFilter {
  public PageNumber: number;
  public PageSize: number;
  public SortColumn: string;
  public SortOrder: string;
  public FilterParamString: string;
  public EngagementId: string;
  public CreditorId: string;

}
export enum ProxyFormGridColumn {
  BroadcastName = 'BroadcastName',
  DocumentType = 'DocumentType',
  PublishDate = 'PublishDate',
  SubmittedFileName = 'SubmittedFileName',
  SubmittedDateAndTime = 'SubmittedDateAndTime',
  SubmittedBy = 'SubmittedBy'
}
